<template>
	<!-- allow to break long words which do not fit into content -->
	<div class="uk-text-break">
		<!-- <transition> -->
		<!-- <keep-alive include="OwnerList"> -->
		<!-- <router-view></router-view> -->
		<!-- </keep-alive> -->
		<!-- </transition> -->

		<router-view v-slot="{ Component, route }">
			<!-- <transition :name="route.meta.transition || 'fade'" mode="out-in"> -->
			<keep-alive include="DeviceListAll">
				<component :is="Component" :key="route.meta.usePathKey ? route.path : undefined" />
			</keep-alive>
			<!-- </transition> -->
		</router-view>

	</div>
</template>

<style>
/* Allows setting font-family to "Open Sans" in src/assets/styles/styles.scss */
@import url("https://fonts.googleapis.com/css?family=Open+Sans");
</style>